import type { AccessOverviewTab } from './types';

// --- Action types ---

export type LoadUserAction = { type: 'LOAD_USER'; userId: string; firmId: string | null };
export const loadUser = (userId: string, firmId: string | null = null): LoadUserAction => ({
    type: 'LOAD_USER',
    userId,
    firmId,
});

export type DataReadyAction = { type: 'DATA_READY' };
export const dataReady = (): DataReadyAction => ({ type: 'DATA_READY' });

export type DataErrorAction = { type: 'DATA_ERROR'; error: string };
export const dataError = (error: string): DataErrorAction => ({
    type: 'DATA_ERROR',
    error,
});

export type SelectNodeAction = { type: 'SELECT_NODE'; nodeId: string | null };
export const selectNode = (nodeId: string | null): SelectNodeAction => ({
    type: 'SELECT_NODE',
    nodeId,
});

export type SetSearchQueryAction = { type: 'SET_SEARCH_QUERY'; query: string };
export const setSearchQuery = (query: string): SetSearchQueryAction => ({
    type: 'SET_SEARCH_QUERY',
    query,
});

export type SetActiveTabAction = { type: 'SET_ACTIVE_TAB'; tab: AccessOverviewTab };
export const setActiveTab = (tab: AccessOverviewTab): SetActiveTabAction => ({
    type: 'SET_ACTIVE_TAB',
    tab,
});

// --- Union ---

export type AccessOverviewAction =
    | LoadUserAction
    | DataReadyAction
    | DataErrorAction
    | SelectNodeAction
    | SetSearchQueryAction
    | SetActiveTabAction;
